import zhlang from "./zh.json"
const zhPackage = {
  ...zhlang,
};
export default zhPackage;
